import { Reveal } from "./motion";
import { scrollToId } from "./smooth";
import { Linkedin, ArrowUpRight } from "lucide-react";

export const Closing = () => (
  <footer className="bg-ink text-white" data-testid="closing-footer">
    <div className="mx-auto max-w-[1400px] px-5 py-20 sm:px-8 sm:py-28">
      <Reveal className="font-display text-2xl font-black italic text-white">— Rui Guedes</Reveal>
      <Reveal delay={0.1} className="mt-8">
        <a
          href="https://pt.linkedin.com/in/ruiguedes"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="closing-linkedin-link"
          className="group inline-flex items-center gap-3 rounded-full border border-white/25 px-6 py-3 font-display text-base font-bold text-white transition-[background-color,border-color,transform] duration-300 hover:-translate-y-1 hover:border-orange hover:bg-orange"
        >
          <Linkedin className="h-5 w-5" />
          Siga o Rui Guedes no LinkedIn
          <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:rotate-45" />
        </a>
      </Reveal>
    </div>
    <div className="border-t border-white/10">
      <div className="mx-auto flex max-w-[1400px] flex-col items-start justify-between gap-6 px-5 py-8 sm:flex-row sm:items-center sm:px-8">
        <span className="inline-flex items-center rounded-2xl bg-white px-4 py-3" data-testid="footer-grupo-si-logo">
          <img src="/img/grupo-si.png" alt="Grupo Soluções Ideais" className="h-12 w-auto" />
        </span>
        <p className="text-sm text-slate-300">© {new Date().getFullYear()} Grupo Soluções Ideais. Rede nacional de franchising imobiliário.</p>
        <button onClick={() => scrollToId("top")} data-testid="footer-back-to-top" className="link-underline text-sm font-bold text-white">Voltar ao topo ↑</button>
      </div>
      <div className="mx-auto max-w-[1400px] px-5 pb-8 sm:px-8">
        <a href="https://pt.linkedin.com/in/ruiguedes" target="_blank" rel="noopener noreferrer" data-testid="footer-linkedin-link" className="group inline-flex items-center gap-2 text-sm text-slate-300 transition-[color] duration-300 hover:text-orange">
          <Linkedin className="h-4 w-4" /> LinkedIn — Rui Guedes
        </a>
      </div>
    </div>
  </footer>
);
